import PublicRoute from "./PublicRoute";
import ProtectedRoute from "./ProtectedRoute";
import { Route, Routes } from "react-router-dom";

import { General } from "@pages/auth/financial/General";
import { Dashboard } from "@pages/auth/DashboardBeautiful";
import { Account } from "@pages/auth/account/Account";
import { RaffleDefaultNumberPreview } from "@pages/auth/raffles/default/preview/number";
import { RaffleDefaultWordPreview } from "@pages/auth/raffles/default/preview/word";
import { MyDefaultRaffleView } from "@pages/auth/raffles/default/MyDefaultRaffleView";
import { MyRaffleDefaultList } from "@pages/auth/raffles/default/MyRaffleDefaultList";
import { Modal4Test } from "@pages/test/4modals/test";
import { MyDefaultRaffleNew } from "@pages/auth/raffles/default/new/MyDefaultRaffleNew";
import { MyDefaultRaffleRewardCreate } from "@pages/auth/raffles/default/reward/MyDefaultRaffleRewardCreate";
import { Land } from "@pages/public/Land";
import { Auth } from "@pages/public/Auth";
import { Earnings } from "@pages/auth/financial/History/Earnings";
import { Withdraw } from "@pages/auth/financial/History/Withdraw";
import { MyRaffleAffiliates } from "@pages/auth/raffles/default/affiliate/affiliate";
import { MyRaffleDefaultTickets } from "@pages/auth/raffles/default/tickets/tickets";
import { CustomerList } from "@pages/auth/customer/list";
import { ClientList } from "@pages/auth/client/list";
import { ProfileMain } from "@pages/auth/profile/Main";
import { CampaignDefaultList } from "@pages/auth/raffles/default/DefaultList";
import { DefaultRaffleVisit } from "@pages/auth/raffles/default/DefaultRaffleVisit";
import { NotificationList } from "@pages/auth/notification/list";
import { NotificationTest } from "@pages/test/notification";
import { CampaignDefaultCustomerList } from "@pages/auth/raffles/default/DefaultCustomerList";
import { CampaignDefaultAffiliateList } from "@pages/auth/raffles/default/DefaultAffiliateList";
import { MyRaffleAffiliations } from "@pages/auth/raffles/default/my-affiliations";

export default function AppRoutes() {
  return (
    <>
      <Routes>
        {/* Public Routes with PublicRoute wrapper */}
        <Route element={<PublicRoute />}>
          <Route path="/" element={<Land />} />
          <Route path="/login" element={<Auth />} />
        </Route>

        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />

          {/* Explore */}
          <Route path="/customer/list" element={<CustomerList />} />
          <Route path="/client/list" element={<ClientList />} />
          <Route
            path="/campaign/default/list"
            element={<CampaignDefaultList />}
          />
          <Route
            path="/campaign/default/customer/list/:atsign"
            element={<CampaignDefaultCustomerList />}
          />
          <Route
            path="/campaign/default/affiliate/list/:atsign"
            element={<CampaignDefaultAffiliateList />}
          />

          <Route
            path="/raffle/my-affiliations"
            element={<MyRaffleAffiliations />}
          />

          {/* Raffle */}
          <Route
            path="/raffles/default/list"
            element={<MyRaffleDefaultList />}
          />
          <Route
            path="/raffle/default/number/preview"
            element={<RaffleDefaultNumberPreview />}
          />
          <Route
            path="/raffle/default/word/preview"
            element={<RaffleDefaultWordPreview />}
          />
          <Route
            path="/raffle/default/reward/create"
            element={<MyDefaultRaffleRewardCreate />}
          />
          <Route
            path="/raffle/default/view" // To Owner
            element={<MyDefaultRaffleView />}
          />
          <Route
            path="/raffle/default/visit" // To Visitors
            element={<DefaultRaffleVisit />}
          />
          <Route path="/raffle/default/new" element={<MyDefaultRaffleNew />} />
          <Route path="/raffle/affiliates" element={<MyRaffleAffiliates />} />
          <Route
            path="/raffle/default/tickets"
            element={<MyRaffleDefaultTickets />}
          />

          {/* Financial */}
          <Route path="/financial/general" element={<General />} />
          <Route path="/financial/history/earnings" element={<Earnings />} />
          <Route path="/financial/history/withdraw" element={<Withdraw />} />

          {/* Notification */}
          <Route path="/notifications" element={<NotificationList />} />

          {/* Customer Account */}
          <Route path="/account" element={<Account />} />
          <Route path="/profile" element={<ProfileMain />} />

          <Route path="/modal4test" element={<Modal4Test />} />

          {/* Test Notification */}
          <Route path="/test/notification" element={<NotificationTest />} />

          {/* Help */}
          {/* <Route path="/faq" element={<Customization />} />
            <Route path="/help" element={<Customization />} />
            <Route path="/terms" element={<Terms />} />
            */}
        </Route>
      </Routes>
    </>
  );
}
